import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientDetail from "@/pages/ClientDetail";
import ClientPublic from "@/pages/ClientPublic";
import Landing from "@/pages/Landing";
import { AuthProvider, useAuth } from "@/lib/auth";

function RequireAuth({ children }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: { fontFamily: "IBM Plex Sans, sans-serif" },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/clientes/:id"
            element={
              <RequireAuth>
                <ClientDetail />
              </RequireAuth>
            }
          />
          <Route path="/cliente/:slug" element={<ClientPublic />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
